import React from 'react'

export function SessionLoadingShell({ label = 'Loading session…' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className="p-6 text-white/70 text-sm"
    >
      {label}
    </div>
  )
}
